import { computed } from 'vue';
import { useFlag } from '@loadsmart/vue-feature-flags';

export function useEnhancedYMSExperience() {
  const featureFlagEnhancedYMSExperience = useFlag('enable-perf-improvements');

  const isEnhancedYMSExperienceEnabled = computed(() =>
    Boolean(featureFlagEnhancedYMSExperience.value?.enabled)
  );

  return {
    isEnhancedYMSExperienceEnabled
  };
}
